export const brandIdentity = {
  name: "TechniaHQRobot",
  displayName: "TechniaHQRobot Humanoid Robots & Physical AI",
  handle: "@techniahqrobot",
  description:
    "Independent robotics media covering humanoid robots, Physical AI, embodied AI, automation, autonomous systems, robot hardware and real-world robot demonstrations.",
  seoDescription:
    "TechniaHQRobot covers humanoid robots, Physical AI, embodied AI, automation, robotics hardware, software and real-world deployments.",
  baseUrl: "https://www.techniahqservice.com",
  logoPath: "/techniahqrobot-logo-20260715.png",
  email: "service@techniahqservice.com",
  social: {
    instagram: {
      name: "Instagram",
      handle: "@techniahqrobot",
      visibleUrl: "https://www.instagram.com/techniahqrobot/",
      canonicalProfileUrl: "https://www.instagram.com/techniahqrobot/",
    },
    x: {
      name: "X",
      handle: "@techniahqrobot",
      visibleUrl: "https://x.com/techniahqrobot",
      canonicalProfileUrl: "https://x.com/techniahqrobot",
    },
    facebook: {
      name: "Facebook",
      handle: "@techniahqrobot",
      visibleUrl: "https://www.facebook.com/techniahqrobot",
      canonicalProfileUrl: "https://www.facebook.com/techniahqrobot",
    },
    tiktok: {
      name: "TikTok",
      handle: "@techniahqrobot",
      visibleUrl: "https://www.tiktok.com/@techniahqrobot",
      canonicalProfileUrl: "https://www.tiktok.com/@techniahqrobot",
    },
    youtube: {
      name: "YouTube",
      handle: "@techniahqrobot",
      visibleUrl: "https://www.youtube.com/@techniahqrobot",
      canonicalProfileUrl: "https://www.youtube.com/@techniahqrobot",
    },
  },
};

export const brandAlternateNames = ["TechniaHQ", "techniahqservice.com"];

export const organizationSameAs = Object.values(brandIdentity.social)
  .map((profile) => profile.canonicalProfileUrl)
  .filter(Boolean);

export function buildOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${brandIdentity.baseUrl}/#organization`,
    name: brandIdentity.name,
    alternateName: brandAlternateNames,
    url: `${brandIdentity.baseUrl}/`,
    logo: {
      "@type": "ImageObject",
      url: `${brandIdentity.baseUrl}${brandIdentity.logoPath}`,
    },
    description: brandIdentity.description,
    email: brandIdentity.email,
    sameAs: organizationSameAs,
  };
}
